import GameInterface from 'interfaces/game-interface';

export default class GameModel implements GameInterface {
    public isLocked: boolean = false;
    public isActive: boolean = false;

    constructor(
        public gameDate: string,
        public gameInfo: string,
        public gameTime: string,
        public gameTimestamp: number,
        public gameTotal: number,
        public isStarted: boolean,
        public status: string,
        public teams: {[key: string]: number},
    ) {
        this.isActive = !inArray(status.toLowerCase(), ['canceled', 'postponed', 'suspended']);
    }

    public lockIfStarted(): void {
        this.isStarted && (this.isLocked = true);
    }

    public static fromGamePayload(payload): GameInterface {
        return new GameModel(
            payload.gameDate,
            payload.gameInfo,
            payload.gameTime,
            payload.gameTimestamp,
            payload.gameTotal,
            payload.isGameStarted,
            payload.status ?? 'scheduled',
            payload.teams,
        );
    }
}
